<template>
  <div>
    <LKProgressCircular
      v-if="isLoadingAsyncData"
      overlay
      :size="50"
      style="align-items: start; padding-top: 30vh;"
    />

    <MainForm
      v-else
      :mun-meh="single"
      :form-id="formId"
      :slug="slug"
      :topic-slug="topicSlug"
      :levels="levels"
    />
  </div>
</template>

<script>
import LKMunMehExpertView from '@/views/LKMunMeh/Review/LKMunMehExpertView.vue'
import { LKMunMehHostViewMapper as StoreMapper } from '@/views/LKMunMeh/HostView/store'

const MainForm = () => import(
  /* webpackChunkName: "LKMunMehMainForm" */
  '@/views/LKMunMeh/HostView/components/LKMunMehHostViewForm.vue'
)

export default {
  name: 'LKMunMehFormView',
  components: {
    MainForm,
  },
  extends: LKMunMehExpertView,
  created() {
    this.resetState()
  },
  methods: StoreMapper.mapMutations(['resetState']),
}
</script>

